import { AccountSchoolIcon } from './AccountSchoolIcon';

/**
 * author: Contributors
 * id BE45DEDF-3BBC-442F-9EDD-4A16570B91A0
 * name account-school
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-school.svg
 * tags
 * - Account / User 
 */
export const AccountStudentIcon = AccountSchoolIcon;
export default AccountStudentIcon